import React from 'react';
import logo from '../assets/peticle-icon.png';

function Header() {
    return (
        <header className="fixed inset-x-0 top-0 z-10 w-full bg-surface/90 backdrop-blur border-b border-border">
            <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-5xl">
                <div className="flex items-center justify-between h-16 lg:h-20">
                    <div className="flex-shrink-0">
                        <a href="/" title="Peticle" className="flex items-center gap-2">
                            <img className="rounded-xl" src={logo} width={36} height={36} alt="Peticle logo" />
                            <span className="text-lg font-extrabold tracking-tight text-text">
                                Peticle
                            </span>
                        </a>
                    </div>

                    <div className="flex items-center gap-6">
                        <a href="/privacy-policy" title="Privacy Policy" className="text-decoration-none text-sm font-semibold text-muted hover:text-text transition-colors">
                            Privacy Policy
                        </a>
                        <a href="/data-settings" title="Data Settings" className="text-decoration-none text-sm font-semibold text-muted hover:text-text transition-colors">
                            Data Settings
                        </a>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
